import React from 'react';
import {
    Dialog,
    DialogProps,
    DialogContent,
    DialogTitleProps,
    DialogContentProps,
    DialogActionsProps,
} from '@carrotfertility/carotene-core';
import { DialogActionsBar, DialogTitleWithImage } from './blocks';

let id_counter = 0;

export type ConfirmationDialogProps = DialogProps & {
    /**
     * The slot for your Primary Action. Most cases should be a `Button`
     */
    primaryAction: React.ReactNode;
    /**
     * The slot for your Secondary Action. Most cases should be an outlined, secondary `Button`
     */
    secondaryAction: React.ReactNode;
    /**
     * The slot for your Tertiary Action. Most cases should be a text, secondary `Button` or a `Link`
     */
    tertiaryAction?: React.ReactNode;
    /**
     * The title text of your Dialog
     */
    title: string;
    /**
     * Component slot for your Dialog image. Please use `DialogTitleImage`.
     */
    image?: React.ReactNode | React.ReactNode[];
    /**
     * Props that allow you to update components you don't have control over. In this case, `slotProps.form` will most likely be your best friend for interacting with the underlying `Form` component
     */
    slotProps?: {
        title?: DialogTitleProps;
        content?: DialogContentProps;
        actions?: DialogActionsProps;
    };
};

export function ConfirmationDialog(props: ConfirmationDialogProps) {
    const { title, children, slotProps, image, primaryAction, secondaryAction, tertiaryAction, ...otherProps } = props;
    const [ariaId] = React.useState(id_counter++);
    const titleId = `confirmation-dialog-${ariaId}-title`;
    return (
        <Dialog aria-labelledby={titleId} {...otherProps}>
            <DialogTitleWithImage id={titleId} image={image} {...slotProps?.title}>
                {title}
            </DialogTitleWithImage>
            <DialogContent {...slotProps?.content}>{children}</DialogContent>
            <DialogActionsBar
                {...slotProps?.actions}
                primaryAction={primaryAction}
                secondaryAction={secondaryAction}
                tertiaryAction={tertiaryAction}
            />
        </Dialog>
    );
}
